import { Injectable } from '@angular/core';
import { assertNonNullable } from '@examdojo/core/util/assert';
import { UserQuery } from '@examdojo/user';
import { tap } from 'rxjs';
import { ReviewPermissionsStore } from './review-permissions.store';
import { UserReviewModeBindingsHttpService } from './user-review-mode-bindings-http.service';

@Injectable({ providedIn: 'root' })
export class ReviewPermissionsService {
  constructor(
    private readonly userReviewModeBindingsHttpService: UserReviewModeBindingsHttpService,
    private readonly reviewPermissionsStore: ReviewPermissionsStore,
    private readonly userQuery: UserQuery,
  ) {}

  fetchUserPermissions() {
    const userId = this.userQuery.getActiveId();
    assertNonNullable(userId, 'userId');

    return this.userReviewModeBindingsHttpService
      .fetchUserPermissions(userId)
      .pipe(
        tap((permissions) =>
          this.reviewPermissionsStore.updateStore((state) => ({ ...state, reviewPermissions: permissions })),
        ),
      );
  }
}
